var styles = {"wrapper":"Loader-module_wrapper__nbgeg","circle":"Loader-module_circle__HJPoP","splash-screen-loading-disc-animation":"Loader-module_splash-screen-loading-disc-animation__-gn3p","big":"Loader-module_big__D-5b4","medium":"Loader-module_medium__SM2s2","small":"Loader-module_small__-6fT2","alert":"Loader-module_alert__fDqHc"};

export { styles as default };
//# sourceMappingURL=Loader.module.scss.js.map
